import {
  SearchableVendorTaxonomyKey,
  VendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace';
import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';
import { CoupleDetailView, UpdateCouplePreferenceRequest } from '@zola/svc-marketplace-ts-types';

import { saveAccountPreference } from '~/actions/couples/accountPreferencesActions';
import { getMiniQuizUserSettingForTaxonomy } from '~/pages/couples/explore/components/MiniQuiz/miniQuizUserSettings';
import { AppDispatch } from '~/reducers';
import ApiService from '~/util/apiService';
import { StandardLogFn } from '~/util/logger';

import {
  receivedMiniQuiz,
  receivedMiniQuizError,
  receivedMiniQuizGuest,
} from './types/miniQuizActionTypes';
import { setUserSetting } from './userSettingsActions';

export const loadMiniQuizAnswers = (
  taxonomyKey: SearchableVendorTaxonomyKey,
  guestMiniQuiz = false
) => {
  return (dispatch: AppDispatch) => {
    if (guestMiniQuiz) {
      dispatch(receivedMiniQuizGuest({ taxonomyKey }));
      return Promise.resolve();
    }
    return ApiService.get<CoupleDetailView>(
      `/web-marketplace-api/v2/couple-preference/${taxonomyKey}`
    )
      .then((details) => {
        dispatch(receivedMiniQuiz({ details, taxonomyKey }));
      })
      .catch((error) => {
        StandardLogFn(error);
        dispatch(receivedMiniQuizError({ taxonomyKey }));
      });
  };
};

export const submitMiniQuiz = (
  requestObj: Omit<UpdateCouplePreferenceRequest, 'userObjectId'>,
  taxonomyKey: VendorTaxonomyKey,
  trackFlowCompleted: () => void,
  onQuizSubmitted: () => void
) => {
  return (dispatch: AppDispatch) => {
    // Opts into MTFM for wedding details (needed to collect wedding details)
    return ApiService.put<CoupleDetailView, Omit<UpdateCouplePreferenceRequest, 'userObjectId'>>(
      `/web-marketplace-api/v2/couple-preference/${taxonomyKey}`,
      requestObj
    )
      .then(() => {
        // Opts into all MTFM options (needed for single opt-in)
        return dispatch(
          saveAccountPreference(
            [
              { key: 'FIRST_MOVES_SHARE_FAVORITES', enabled: true },
              { key: 'FIRST_MOVES_SHARE_INQUIRIES', enabled: true },
              { key: 'FIRST_MOVES_SHARE_WEDDING_DETAILS', enabled: true },
            ],
            'POST_ACTION_PROMPT',
            isMobile() ? 'MOBILE_WEB' : 'WEB'
          )
        );
      })
      .then(() => {
        return dispatch(setUserSetting(getMiniQuizUserSettingForTaxonomy(taxonomyKey)));
      })
      .then(() => {
        trackFlowCompleted();
      })
      .then(() => {
        onQuizSubmitted();
      });
  };
};
